module.exports = __webpack_public_path__ + "img/tools1.27b3574f.png";